function customError(name, defaultMessage) {

  const rv = function (message) {
    this.name = name;
    this.message = message || defaultMessage || 'Custom Error';
    this.stack = (new Error()).stack;
  };

  rv.prototype = Object.create(Error.prototype);
  rv.prototype.constructor = rv;

  return rv;
}

export const UnableToConnectException = customError('UnableToConnectException', 'Unable to connect to the server.');
export const NotFoundException = customError('NotFoundException', 'Endpoint not found.');
export const AuthenticationException = customError('AuthenticationException', 'User is not authenticated.');
export const BadRequestException = customError('BadRequestException', 'Bad request sent.');
export const TimeoutException = customError('TimeoutException', 'The request timed out.');
